import { Box, Typography, Link } from '@mui/material'
import { NavBar } from './Navigation'
import { useComponentSizeAndPosition } from '../shared/utils'
import { DVD } from './DVD'
import { LoadingPicture } from '../shared/LoadingPicture'

export function Registry() {
  const isMobile = window.innerWidth < 768

  return isMobile ? <RegistryMobile /> : <RegistryDesktop />
}

function RegistryMobile() {
  const { boxRef } = useComponentSizeAndPosition()

  return (
    <Box
      ref={boxRef}
      sx={{
        width: '100vw',
        height: '100vdh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          padding: '10px',
          bottom: 0,
          width: '100%',
          zIndex: 1,
          backgroundColor: 'rgba(255, 255, 255, 1.0)',
        }}
      >
        <NavBar direction="row" />
      </Box>
      <LoadingPicture
        imageId="wedding_cheeto_registry.jpg"
        size="medium"
        stage="prod"
        style={{
          padding: '0px 20px',
          width: '100%',
          height: 'auto',
          objectFit: 'cover',
        }}
      />
      <Box sx={{ padding: '40px' }}>
        <BodyText />
      </Box>
    </Box>
  )
}

function RegistryDesktop() {
  const { width, height, boxRef } = useComponentSizeAndPosition()

  return (
    <Box ref={boxRef} sx={{ position: 'relative', height: '100vh' }}>
      {width && height && (
        <DVD
          containerHeight={height}
          containerWidth={width}
          initialX={width - 200}
          initialY={height - 400}
          radius={100}
          text="Big yellow button"
        />
      )}
      <Box sx={{ padding: '10px' }}>
        <NavBar direction="row" />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          padding: '20px',
        }}
      >
        <LoadingPicture
          imageId="wedding_cheeto_registry.jpg"
          size="medium"
          stage="prod"
          style={{
            // height: 'calc(100vh - 100px)',
            width: '450px',
            // minWidth: '300px',
            objectFit: 'cover',
            marginRight: '30px',
          }}
        />
        <Box sx={{ width: '300px', padding: '20px' }}>
          <BodyText />
        </Box>
      </Box>
    </Box>
  )
}

function BodyText() {
  return (
    <>
      <Typography variant="body1" paragraph fontWeight="bold">
        {'Your presence is a present to us <3'}
      </Typography>
      <Typography variant="body1" paragraph fontWeight="bold">
        {
          'In Singapore and China, wedding/vow renewal guests traditionally offer 🧧ang pow or hong bao 🧧(红包), aka red packets, as a form of blessing and a symbol of prosperity and luck for the happy couple.'
        }
      </Typography>
      <Typography variant="body1" paragraph fontWeight="bold">
        {
          'If you’d like to gift us a digital red packet, you can do so via venmo @TammyTan or @Jay-Ou. Or, if you prefer, we will have a special ang pow box at the event.'
        }
      </Typography>
      <Typography variant="body1" paragraph fontWeight="bold">
        {'Cheeto says thank you to his aunties and uncles 🥺.'}
      </Typography>
    </>
  )
}
